import Vue from 'vue';
import _ from 'lodash';
import { StatusUtils } from 'status-utils';
import CryptoJS from 'crypto-js';
import axios from '../../../axios';
import tmsMdmAxiosInstance from '@/tms-mdm-axios';
import HandleResponses from '@common/utils/handleResponses';
import { getDecrypt } from '../../../utils/permission';

const actions = {

  async bootstrap({ commit, dispatch }, loading = false) {
    try {
      commit('BOOTSTRAP_LOADING', true);
      const result = await axios('/bootstrap');
      const currentUser = result.data && result.data.current_user;
      if (currentUser) {
        currentUser.permissions_list =
          getDecrypt(currentUser.permissions_list, currentUser.id);
        currentUser.dashboard_permission_list =
          getDecrypt(currentUser.dashboard_permission_list, currentUser.id);
      }
      result.data.features = getDecrypt(result.data.features, result.data.client.id);
      const statusUtils =
      new StatusUtils(result.data.status.list, result.data.status.mapping);
      Vue.prototype.$statusUtil = statusUtils;
      commit('BOOTSTRAP_DATA', result.data);
      commit('LOGGED_IN', true);
      dispatch('app/mdmBootstrap', { loading: true }, { root: true });
      return result.data;
    } catch (err) {
      return err;
    } finally {
      if (!loading) {
        commit('BOOTSTRAP_LOADING', false);
      }
    }
  },
  async generateToken(_, { data }) {
    try {
      let apiData;
      const result = await axios.post('/generate_otp', { data });
      if (result && result.otp_response) {
        const appSecret = window.location.origin.replace(/\/|http:|https:/gi, () => ''); // To extract the domain_url
        const bytes = CryptoJS.AES.decrypt(result.otp_response, appSecret);
        apiData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return apiData;
    } catch (err) {
      return err;
    }
  },

  async verifyToken(_, { data }) {
    try {
      const result = await axios.post('/verify_otp?platform=web', { data });
      return result;
    } catch (err) {
      return err;
    }
  },
  async login({ commit }, { data }) {
    try {
      const result = await axios.put('/login', { data });
      if (result === '') {
        commit('LOGGED_IN', true);
      }
      let responseData;
      if (result && result.otp_response) {
        const appSecret = window.location.origin.replace(/\/|http:|https:/gi, () => ''); // To extract the domain_url
        const bytes = CryptoJS.AES.decrypt(result.otp_response, appSecret);
        const apiData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        responseData = apiData;
      } else {
        responseData = result;
      }
      return responseData;
    } catch (err) {
      return err;
    }
  },
  async loginV3({ commit }, { data }) {
    try {
      const result = await axios.put('/login-v3?platform=web', { data });
      if (result === '') {
        commit('LOGGED_IN', true);
      }
      let responseData;
      if (result && result.otp_response) {
        const appSecret = window.location.origin.replace(/\/|http:|https:/gi, () => ''); // To extract the domain_url
        const bytes = CryptoJS.AES.decrypt(result.otp_response, appSecret);
        const apiData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        responseData = apiData;
      } else {
        responseData = result;
      }
      return responseData;
    } catch (err) {
      return err;
    }
  },

  async fcmToken({ commit }, token) {
    try {
      if (token) {
        commit('FCM_TOKEN', token);
        await axios.put('/fcm_update', { data: { token } });
      } else {
        console.log('Live Notification disabled - No FCM found!!');
      }
    } catch (error) {
      console.log('error', error);
      return error;
    }
  },

  async acceptTerms() {
    try {
      const result = await tmsMdmAxiosInstance.put('/user/accept_terms_conditions');
      return result;
    } catch (err) {
      return err;
    }
  },

  async setReleaseNotesViewed() {
    try {
      const result = await tmsMdmAxiosInstance.put('/user/viewed_release_updates');
      return result;
    } catch (err) {
      return err;
    }
  },

  async ssoCheck({ commit }) {
    try {
      const result = await axios.get('/ssocheck');
      commit('SET_SSO', result);
      return result;
    } catch (err) {
      return err;
    }
  },
  async logout(_, { data }) {
    try {
      const result = await axios.put('/logout', { });
      const optimaOutputHeaders = localStorage.getItem('Optima-selected-headers');
      const optimaInputHeaders = localStorage.getItem('optima-input-selected-headers');
      const tableParameters = localStorage.getItem('tableParameters');
      localStorage.clear();
      if (optimaOutputHeaders) localStorage.setItem('Optima-selected-headers', optimaOutputHeaders);
      if (optimaInputHeaders) localStorage.setItem('optima-input-selected-headers', optimaInputHeaders);
      if (tableParameters) localStorage.setItem('tableParameters', tableParameters);
      if (data && data.message) {
        window.alert(data.message);
      }
      window.location = '/login';
      return result;
    } catch (err) {
      return err;
    }
  },

  async changeProfile({ commit }, { data }) { // eslint-disable-line
    try {
      await tmsMdmAxiosInstance.put('/user/password', { data });
      return { result: true };
    } catch (err) {
      return { result: false, errMsg: err.data.errors[0].message };
    }
  },

  async forgotPassword({ commit }, { data }) { // eslint-disable-line
    try {
      const result = await tmsMdmAxiosInstance.put('/user/forgot_password', { data });
      return result;
    } catch (err) {
      return err;
    }
  },
  async getPackingManifest() {
    try {
      const result = await axios.get('/packing/get_manifest');
      return result;
    } catch (err) {
      return err;
    }
  },
  async updatePackingManifest(_, { data }) {
    try {
      const result = await axios.post('/packing/generate_manifest', { data });
      return result;
    } catch (err) {
      return err;
    }
  },
  async getManifestDocument(_, { data }) {
    try {
      const result = await axios.get('/packing/manifest', { params: data });
      return result;
    } catch (err) {
      return err;
    }
  },

  async mdmBootstrap({ commit }, { loading = false }) {
    try {
      commit('BOOTSTRAP_LOADING', true);
      const result = await axios('/bootstrap/mdm');
      commit('MDM_BOOTSTRAP_DATA', result.data);
      commit('LOGGED_IN', true);
      return result.data;
    } catch (err) {
      return err;
    } finally {
      if (!loading) {
        commit('BOOTSTRAP_LOADING', false);
      }
    }
  },
  async getLocales(_, locale) {
    try {
      const result = await axios.get(`/localisation/${locale}`);
      return result.data;
    } catch (err) {
      return err;
    }
  },
  async reCaptchaVerify(_, reCaptchaVerify) {
    return axios.post('/verify-captcha', { token: reCaptchaVerify });
  },

  async getRateQuoteFromCarrier(_, payload) {
    try {
      const params = new URLSearchParams(payload).toString();
      const result = await axios.get(`/ratelookup/rate?${params}`);
      return result;
    } catch (err) {
      return err;
    }
  },

  async getLocationMappings() {
    try {
      const result = await axios.get('/ratelookup/location-mappings');
      return result;
    } catch (err) {
      return { data: { locations: [] } };
    }
  },

  async getWorkflowsList() {
    try {
      const result = await axios.get(`/workflow?page=${1}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getWorkflowsDetail(_, workflowId) {
    try {
      const result = await axios.get(`/workflow/${workflowId}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getPrePostEvents() {
    try {
      const result = await axios.get('/workflow/pre_post_events');
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async updateWorkflowsDetail(_, { workflowId, payload }) {
    try {
      const result = await axios.put(`/workflow/${workflowId}`, { data: payload });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async createWorkflow(_, { payload }) {
    try {
      const result = await axios.post('/workflow', { data: payload });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
};

export default actions;
